import * as ROUTES from './common/routes';
import Home from './components/Home';
import NotFound from './components/NotFound';
import AlbumMap from './components/AlbumMap';
import AlbumAdd from './components/AlbumAdd';
import React from 'react';
import configureStore from './redux/configureStore';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { getTheme } from './common/theme';
import AlbumView from './components/AlbumView';
import Layout from './components/Layout';
import SearchResults from './components/SearchResults';
import {
  CssBaseline,
  MuiThemeProvider,
  Theme,
  StylesProvider,
} from '@material-ui/core';

const store: Store = configureStore();
const theme: Theme = getTheme();

const App = () => {
  return (
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <StylesProvider injectFirst>
          <Router>
            <Layout>
              <Switch>
                <Route exact path={ROUTES.ROOT} component={Home} />
                <Route exact path={ROUTES.MAP} component={AlbumMap} />
                <Route exact path={ROUTES.ADD} component={AlbumAdd} />
                <Route
                  exact
                  path={ROUTES.SEARCH}
                  component={(routerProps) => (
                    <SearchResults {...routerProps} />
                  )}
                />
                <Route exact path={'/:pageId'} component={AlbumView} />
                <Route exact path={'/:pageId/:storyId'} component={AlbumView} />
                <Route path="*" component={NotFound} />
              </Switch>
            </Layout>
          </Router>
        </StylesProvider>
      </MuiThemeProvider>
    </Provider>
  );
};

export default App;
